import { ShowHubspotCompanyOverviewResponseSchema } from './show-hubspot-company-overview.schema';
/**
 * Show HubSpot Company Overview Endpoint Contract
 * Super-admin preview of a HubSpot company (basics + licenses + status) for the
 * tenant create/edit dialog. Super-admin only.
 */ export const showHubspotCompanyOverviewContract = {
    method: 'GET',
    path: '/api/v2/admin/hubspot-company/:companyId',
    description: 'Super-admin preview of a HubSpot company (basics + licenses)',
    responseSchema: ShowHubspotCompanyOverviewResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - not a super-admin',
            404: 'Not Found - no HubSpot company with this id',
            502: 'Bad Gateway - HubSpot API request failed'
        }
    }
};

//# sourceMappingURL=show-hubspot-company-overview.contract.js.map